import { render } from "./Materialy.vue?vue&type=template&id=36c11537"
import script from "./Materialy.vue?vue&type=script&lang=js"
export * from "./Materialy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__